import React from 'react';

const CloseButton = ({ onClick, title, showForSR }) => {
    return (
        <button className="close-button" onClick={onClick} type={'button'}>
            {title} {showForSR && <span className="show-for-sr">{showForSR}</span>}
            <span className="close-button__icon"></span>
        </button>
    );
};
export default CloseButton;
